export default __webpack_public_path__ + "static/media/thriving.3fa14ec1.svg";